import {defineArrayMember, defineField} from 'sanity'
import {toPlainText} from '@portabletext/react'

export default defineArrayMember({
  type: 'image',
  options: {
    hotspot: true,
    metadata: ['lqip'],
  },
  fields: [
    defineField({
      name: 'alt',
      type: 'string',
      validation: (Rule) =>
        Rule.warning().info('Describe the image for better accessibility').required(),
    }),
    defineField({
      name: 'figcaption',
      type: 'array',
      of: [
        {
          type: 'block',
          styles: [{title: 'Normal', value: 'normal'}],
        },
      ],
    }),
  ],
  preview: {
    select: {
      alt: 'alt',
      figcaption: 'figcaption',
      media: 'asset',
    },
    prepare: (props) => {
      const {alt, figcaption, media} = props
      const textFigCaption = toPlainText(figcaption || [])
      return {
        title: alt || textFigCaption || 'Image (without alt)',
        media,
      }
    },
  },
})
